import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../services/auth.service';
import { catchError, EMPTY, finalize, take } from 'rxjs';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    standalone: false,
})
export class ForgotPasswordComponent {
    form: FormGroup;
    resetInProgress = false;
    message: string | undefined = undefined;
    isSuccess = false;

    constructor(
        private readonly fb: FormBuilder,
        private readonly authService: AuthService,
    ) {
        this.form = this.fb.group({
            email: ['', [Validators.required, Validators.email]],
        });
    }

    sendResetLink() {
        if (this.form.valid) {
            this.resetInProgress = true;
            this.message = undefined;
            this.isSuccess = false;
            
            this.authService
                .requestResetPassword(this.form.get('email')?.value)
                .pipe(
                    take(1),
                    finalize(() => {
                        this.resetInProgress = false;
                    }),
                    catchError((err) => {
                        this.message = 'حدث خطأ أثناء إرسال رابط إعادة تعيين كلمة المرور';
                        return EMPTY;
                    }),
                )
                .subscribe((result) => {
                    if (result.success) {
                        this.isSuccess = true;
                        this.message = 'تم إرسال رابط إعادة تعيين كلمة المرور إلى بريدك الإلكتروني';
                    } else {
                        this.message = 'حدث خطأ أثناء إرسال رابط إعادة تعيين كلمة المرور';
                    }
                });
        }
    }
}
